export default "__VITE_ASSET__vk5zWjZz__"